import axios from "./axiosinstance";

const TemplateApi = {
  list: () => axios.get("templates/list"),
  add: (payload) => axios.post("templates/add", payload),
  update: (payload) => axios.post("templates/update", payload),
  remove: (payload) => axios.post("templates/delete", payload),
  soldList: () => axios.get("templates/sold-list"),
  exportToSell: (payload) => axios.post("templates/export-to-sell", payload),
  removeFromSell: (payload) => axios.post("templates/remove-from-sell", payload),
};

export default TemplateApi;